var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsibleGamblingEo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12996_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.21484 0.191406L5.05859 2.37891C5.22266 2.51562 5.33203 2.70703 5.33203 2.89844V4.375L8.3125 7.35547C9.10547 6.97266 10.0898 7.10938 10.7461 7.76562L13.8086 10.8281C14.1641 11.1562 14.1641 11.7305 13.8086 12.0586L12.0586 13.8086C11.7305 14.1641 11.1562 14.1641 10.8281 13.8086L7.76562 10.7461C7.10938 10.0898 6.97266 9.07812 7.38281 8.28516L4.40234 5.30469H2.89844C2.70703 5.30469 2.51562 5.22266 2.37891 5.05859L0.191406 2.21484C0 1.94141 0.0273438 1.58594 0.273438 1.33984L1.36719 0.246094C1.58594 0.0273438 1.96875 0 2.21484 0.191406ZM0.601562 10.9102L4.67578 6.83594L6.37109 8.53125C6.20703 9.10547 6.23438 9.73438 6.45312 10.3086L3.22656 13.5352C2.89844 13.8633 2.40625 14.0547 1.91406 14.0547C0.902344 14.0547 0.0820312 13.2344 0.0820312 12.2227C0.0820312 11.7305 0.273438 11.2383 0.601562 10.9102ZM14.082 3.99219C14.082 5.57812 13.1523 6.94531 11.8125 7.57422L11.375 7.13672C10.6094 6.37109 9.51562 6.09766 8.53125 6.37109L6.20703 4.01953V3.99219C6.20703 1.83203 7.95703 0.0546875 10.1445 0.0546875C10.418 0.0546875 10.6914 0.109375 10.9648 0.164062C11.2656 0.21875 11.3477 0.601562 11.1289 0.820312L9.37891 2.57031C9.29688 2.65234 9.26953 2.76172 9.26953 2.87109V4.45703C9.26953 4.67578 9.46094 4.89453 9.70703 4.89453H11.2656C11.375 4.89453 11.4844 4.83984 11.5664 4.75781L13.3164 3.00781C13.5352 2.78906 13.918 2.87109 13.9727 3.17188C14.0273 3.44531 14.082 3.71875 14.082 3.99219ZM1.61328 11.8672C1.61328 12.25 1.88672 12.5234 2.26953 12.5234C2.625 12.5234 2.92578 12.25 2.92578 11.8672C2.92578 11.5117 2.625 11.2109 2.26953 11.2109C1.88672 11.2109 1.61328 11.5117 1.61328 11.8672Z",
    fill: "black",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12996_267",
    x: 0,
    y: 0,
    width: 14.1641,
    height: 15.1641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12996_267"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12996_267",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsibleGamblingEo);
export default ForwardRef;